import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';

const AppBarStyled = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: '100%',
  left: 0
}));

export default AppBarStyled;
